import { useSupabaseAuth } from './auth';
import { cn } from '@/lib/utils';

export interface SignInButtonProps {
  className?: string;
}

export function SignInButton({ className }: SignInButtonProps) {
  const { loading, session, signIn } = useSupabaseAuth();
  const isAnonymous = session?.user?.is_anonymous ?? true;

  if (loading) return null;
  if (!isAnonymous) return null;
  if (!import.meta.env.VITE_LOGIN_REDIRECT_URL && !import.meta.env.VITE_SUPABASE_URL) return null;

  return (
    <div className={cn(className)}>
      <button
        type="button"
        onClick={signIn}
        className="flex items-center gap-2 rounded-lg border border-white/[0.08] bg-white/[0.04] px-4 py-2 text-[13px] font-medium text-zinc-400 transition-colors hover:bg-white/[0.08] hover:text-zinc-200"
      >
        Sign In
      </button>
    </div>
  );
}
